export const COMPANYTAXOVERVIEWADDONLIST_TAXTYPEID = 'COMPANYTAXOVERVIEWADDONLIST_TAXTYPEID';
export const COMPANYTAXOVERVIEWADDONLIST_STARTDATE = 'COMPANYTAXOVERVIEWADDONLIST_STARTDATE';
export const COMPANYTAXOVERVIEWADDONLIST_ENDDATE = 'COMPANYTAXOVERVIEWADDONLIST_ENDDATE';